var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEquipmentLastUpdated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#727A82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.05 2.985c-1.319.178-2.583.746-3.652 1.641-1.051.882-1.908 2.254-2.247 3.597-.166.661-.197.942-.197 1.777s.031 1.116.197 1.777c.337 1.338 1.198 2.717 2.242 3.592.879.737 1.95 1.283 2.99 1.525.989.23 2.222.232 3.263.006 1.99-.434 3.858-1.928 4.749-3.801a7.364 7.364 0 0 0 .622-2.091l.023-.175h-1.27l-.021.125c-.054.33-.222.934-.347 1.246-.303.755-.663 1.29-1.285 1.913-1.21 1.211-2.635 1.771-4.347 1.706-1.319-.049-2.451-.465-3.421-1.257a8.203 8.203 0 0 1-1.157-1.235c-.44-.617-.785-1.453-.931-2.258-.102-.557-.102-1.589 0-2.146.146-.805.491-1.641.931-2.258a8.203 8.203 0 0 1 1.157-1.235 5.689 5.689 0 0 1 2.545-1.175c.328-.062.503-.073 1.106-.073.647.001.758.01 1.137.09a5.984 5.984 0 0 1 3.13 1.778l.35.363-1.084.016-1.083.017v1.233l2.108.009 2.109.008V3.467h-1.234V5.436l-.306-.32a7.07 7.07 0 0 0-4.22-2.135c-.475-.059-1.406-.057-1.857.004m.35 5.073v2.226l1.525 1.524c.839.839 1.54 1.525 1.559 1.525.043 0 .849-.807.849-.85 0-.018-.607-.641-1.35-1.383l-1.35-1.35V5.833H9.4v2.225",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipmentLastUpdated);
export default __webpack_public_path__ + "static/media/equipment-last-updated.96283ee83c5f104abf35a15736013d0a.svg";
export { ForwardRef as ReactComponent };